// extracted by mini-css-extract-plugin
module.exports = {"infosModal":"ModalInfo_infosModal__3pZF3","circle":"ModalInfo_circle__1QTRu","action":"ModalInfo_action__bG8mI","blue":"ModalInfo_blue__10hki","green":"ModalInfo_green__ZRXUl"};